// AICustomerService.vue 第 4 個 v-tab「互動記錄」；通知連結用 ?tab=history 直接打開
export const AI_CS_HISTORY_TAB = 3

export function aiCsTabFromQuery(tab) {
  return tab === 'history' ? AI_CS_HISTORY_TAB : null
}
